import { useState } from 'react';

export const SettingsComponent = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  return (
    <div className='settings-page'>
      <div className='sidebar'>
        <div className='sidebar__title font-h3-regular'>Settings</div>
        <div className='sidebar__inputs font-h5-regular'>
          <span onClick={() => setSelectedTab(1)} className={`sidebar__inputs__subtle-button ${selectedTab == 1 ? 'active' : ''}`}>
            AI model labels
          </span>
          <span onClick={() => setSelectedTab(2)} className={`sidebar__inputs__subtle-button ${selectedTab == 2 ? 'active' : ''}`}>
            Mail settings
          </span>
        </div>
      </div>
      <div className='content font-h2-regular'>
        {selectedTab == 1 ? <div className='content__model-labels'>1</div> : <div className='content__mail'>2</div>}
      </div>
    </div>
  );
};
